import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { trackByValue } from '@y42/angular/util';

@Component({
  selector: 'y42-context-menu-font-family',
  templateUrl: './context-menu-font-family.component.html',
  styleUrls: ['./context-menu-font-family.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContextMenuFontFamilyComponent {
  @Input()
  fontFace?: string;

  @Input()
  fontFamilyList?: string[];

  @Output()
  fontFaceChanged = new EventEmitter<string>();

  readonly trackByValue = trackByValue;
  readonly defaultFontList = ['Arial', 'Segoe UI', 'Helvetica Neue', 'Arial', 'BlinkMacSystemFont'];
}
